import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { Observable, Subject, Subscription, timer } from 'rxjs';

import { Servidor } from '../_classes/servidor';
import { ServidorSrh2 } from '../_classes/servidor-srh2';
import { Util } from '../_classes/util';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { FotoService } from './../_servicos/foto.service';
import { SnackBarService } from './../_servicos/snack-bar.service';

@Component({
  selector: 'app-dados-pessoais',
  templateUrl: './dados-pessoais.component.html',
  styleUrls: ['./dados-pessoais.component.scss'],
})
export class DadosPessoaisComponent implements OnInit {
  private readonly recurso: string = 'dados-pessoais';
  carregando = false;

  servidor$: Observable<Servidor>;
  //servidor: Servidor;

  foto;
  iDataSource: Subscription;

  servidorSrh2$: Observable<ServidorSrh2>;
  servidorSrh2: ServidorSrh2;

  erros$ = new Subject<boolean>();

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private sanitizer: DomSanitizer,
    private _fS: FotoService,
    public servService: ServidorService,
    private alertService: ModalAlertaService,
    private snack: SnackBarService,
    private env: EnvService
  ) {
    this.carregando = true;
  }

  ngOnInit() {
    //console.log('iniciando dados pessoais');
    this.atualizar();
  }

  executarAoCarregarDatasource(x: ServidorSrh2) {
    this.servidorSrh2 = new ServidorSrh2(x);
    const blob = new Blob(
      [
        Util.Base64ToBlob(
          this._fS.getFoto(this.env.servidor?.idServidor?.toString())
        ),
      ],
      {
        type: 'image/bmp',
      }
    );
    let arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    this.foto = arquivoUrl;
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    if (this.env.servidor?.servidorSrh2) {
      this.executarAoCarregarDatasource(this.env.servidor.servidorSrh2);
    }
  }

  copiar(str: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = str;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.snack.abrirSnackBar('Texto copiado com sucesso para memória!');
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
